import { Component, OnInit, Input } from '@angular/core';
import { DayService } from 'src/app/modules/core/services/parameter';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-default-logo-version',
  templateUrl: './default-logo-version.component.html',
  styleUrls: ['./default-logo-version.component.scss'],
})
export class DefaultLogoVersionComponent implements OnInit {
  @Input()
  public includeVersion: boolean;
  public version: string;
  public imgError: boolean;

  constructor(public readonly dayService: DayService) {
    this.dayService.getObservable().subscribe(
      () => {
        this.ngOnInit();
      },
      () => this.errorHandler(),
    );
  }

  /**
   * Init app
   */
  public ngOnInit(): void {
    this.imgError = false;
    this.version = environment.versionComponent;
  }

  /**
   * This function set image source default if image doesn't exists
   */
  public errorHandler(): void {
    this.imgError = true;
  }
}
